const SonarEmitter = {
    init() : void {
        const $sonarEmitters = document.querySelectorAll<HTMLElement>('.sonar-emitter');
        $sonarEmitters.forEach($sonarEmitter => {
            let wavesHTML = '';

            for (let i = 1; i <= 7; i++) {
                wavesHTML += `<div class="sonar-wave wave${i}"></div>`;
            }

            $sonarEmitter.innerHTML = $sonarEmitter.innerHTML + wavesHTML;
        });
    },
};

export default SonarEmitter;
